const mainFilterCat = [
  {
    key: 'Market Cap',
    api: 'market_cap',
    sort: 'market_cap_desc',
  },
  {
    key: 'Circulating Supply',
    api: 'circulating_supply',
    sort: 'circulating_supply',
  },
  {
    key: '24h change vs ATH%',
    api: 'ath_change_percentage',
    sort: 'ath_change_percentage',
  },
];

export default mainFilterCat;
